import { render, staticRenderFns } from "./ApiKey.vue?vue&type=template&id=4a70f862&scoped=true&"
import script from "./ApiKey.vue?vue&type=script&lang=js&"
export * from "./ApiKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70f862",
  null
  
)

export default component.exports